export default __webpack_public_path__ + "static/media/ep_16.5005daa9.png";